import { useNode } from "@craftjs/core";
import { cn } from "@/lib/utils";
import { applyStyleProps, defaultStyleProps, type ResponsiveStyleProps } from "@/lib/craft/style-props";
import { QuoteBlockSettings } from "@/components/craft/settings/QuoteBlockSettings";

type QuoteBlockProps = {
  quote: string;
  attribution?: string;
  style?: ResponsiveStyleProps;
};

export function QuoteBlock({
  quote = "A compelling quote goes here.",
  attribution = "",
  style = defaultStyleProps(),
}: QuoteBlockProps) {
  const {
    connectors: { connect, drag },
    selected,
    id,
  } = useNode((node) => ({ selected: node.events.selected, id: node.id }));
  const { style: inlineStyle, className: styleClass } = applyStyleProps(style, "desktop", id);

  return (
    <blockquote
      ref={(ref) => { if (ref) connect(drag(ref)); }}
      className={cn(
        "my-8 border-l-4 border-gold pl-6 italic",
        `craft-node-${id}`,
        styleClass,
        selected && "outline outline-2 outline-dashed outline-primary/30",
      )}
      style={inlineStyle}
    >
      <p className="text-xl leading-relaxed text-foreground/90 md:text-2xl">&ldquo;{quote}&rdquo;</p>
      {attribution && (
        <footer className="mt-3 text-sm font-semibold not-italic text-primary">{attribution}</footer>
      )}
    </blockquote>
  );
}

QuoteBlock.craft = {
  displayName: "Quote",
  props: { quote: "A compelling quote goes here.", attribution: "", style: defaultStyleProps() },
  rules: { canDrag: () => true },
  related: { settings: QuoteBlockSettings },
};
